module.exports = __webpack_public_path__ + "static/img/1-1.e7d7394.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/eng/1-1.png
// module id = VRam
// module chunks = 0